import { filter, map, withLatestFrom } from 'rxjs/operators';
import { IEpic, isTypeOf } from '@cbridge-utils/redux-observable';
import { UserSettingsAction } from '@cbridge-packages/user-settings';
import { RulesManagementAction } from '../rulesManagement.action';
import { rulesManagementStoreSelector } from '../rulesManagement.selector';
import { IRulesManagementStoreSegment } from '../rulesManagement.interface';
import { rulesSidebarOpenSettingKey } from '../_helpers/rulesSidebarOpenSettingKey';

export const persistRulesSidebarOpenEpic: IEpic<IRulesManagementStoreSegment> = (action$, state$) => action$.pipe(
  isTypeOf(RulesManagementAction.persistSidebarOpen),
  withLatestFrom(state$),
  map(([{ payload }, state]) => ({ isOpen: payload, settingsKey: rulesManagementStoreSelector(state).settingsKey })),
  filter(({ settingsKey }) => Boolean(settingsKey)),
  map(({ isOpen, settingsKey }) => UserSettingsAction.saveSetting({ key: rulesSidebarOpenSettingKey(settingsKey!), value: isOpen })),
);
